import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import {  withRouter } from "react-router-dom";
import ModalCardOk from "../ModalCardOk";
import { formatRawCurrency, isObjectEmpty, getMessage, formatCurrency } from "../../organisms/utils";
import { getMessengerService, getAmountOfTelcelPospago, executeTaggeo } from "../../../store/actions";
import { setFromActionValue, setMaxAmountValue } from "../../../store/actions/domiciliation";
import { roundAmount } from "../../organisms/GenericForm/utils/formatToCurrency";

export default class HasDomiciliationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openHasDomiciliationModal: false,
      CpMessage: "CP0005",
    };
  }

  componentDidMount() {
    const {
      hasDmError,
      hasDmResponse,
      getMessengerService,
      history,
      accountValue,
      amount,
      tagServiceId,
      executeTaggeo,
      setFromActionValue,
      setMaxAmountValue,
      getAmountOfTelcelPospago,
      serviceId,
    } = this.props;
    let alertId = "";
    getMessengerService("PagosProgramados");
    if (!isObjectEmpty(hasDmResponse) && hasDmResponse.data) {
      const {
        data: { domiciliation },
      } = hasDmResponse;
      if (domiciliation) {
        setTimeout(() => {
          this.setState({
            openHasDomiciliationModal: true,
            CpMessage: "CP0014",
          });
        }, 400);

        alertId = "Servicio con pago ya domiciliado";
      } else {
        getAmountOfTelcelPospago(
          accountValue,
          serviceId,
          true
        );
        setFromActionValue("clickButtonDomiciliation")
        setMaxAmountValue(formatRawCurrency(roundAmount(amount.replace(/(,)/gm, ""))))
        setTimeout(() => {
          history.push({
            pathname: `schedule-telcel-bill-payments`,
            state: { accountValue, amount, tagServiceId },
          });
        }, 200);  
      }
    }
    if (hasDmError) {
      getMessengerService("PagosProgramados");
      setTimeout(() => {
        this.setState({ CpMessage: "CP0013", openHasDomiciliationModal: true });
      }, 400);
      alertId = "Domiciliación no completada";
    }
    setTimeout(() => {
      executeTaggeo({
        action: "View alert",
        step:
          tagServiceId === "serviciopagotelcelMenu"
            ? "Pantalla principal"
            : "Formulario de pago",
        service: tagServiceId,
        alert_id: alertId,
        eventName: tagServiceId === "serviciopagotelcelMenu"
          ? "telcel"
          : "pay_service_or_tae",
      });
    }, 800);
  }

  handleOnclickModal = () => {
    const { tagServiceId, executeTaggeo, hasDmError } = this.props;
    this.setState({ openHasDomiciliationModal: false });
    executeTaggeo({
      action: "Click alert Entendido",
      service: tagServiceId,
      step: tagServiceId === "serviciopagotelcelMenu"
        ? "Pantalla principal"
        : "Formulario de pago",       
      alert_id: hasDmError
        ? "Domiciliación no completada"
        : "Servicio con pago ya domiciliado",
      eventName: tagServiceId === "serviciopagotelcelMenu"
      ? "telcel"
      : "pay_service_or_tae",
    });
  };

  render() {
    const { openHasDomiciliationModal, CpMessage } = this.state;
    const { messagesDomiciliation } = this.props;
    let messageInformation = { data: {} };
    if (messagesDomiciliation.length !== 0) {
      messageInformation = getMessage(messagesDomiciliation, CpMessage);
    }
    return (
      <ModalCardOk
        isOpen={openHasDomiciliationModal}
        srcImage={messageInformation.data.icon}
        text={messageInformation.data.subject}
        textdetail={messageInformation.data.message}
        buttontext={"Entendido"}
        onclickModal={this.handleOnclickModal}
        fontSizeTitle={"20px"}
        fontFamilyTitle={"NunitoBold"}
      />
    );
  }
}

function mapStateToProps(state) {
  const { domiciliationReducer: { messagesDomiciliation } = [], payments } =
    state;
  return {
    messagesDomiciliation,
    isContainerTelcel: payments.isContainerTelcel,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMessengerService,
      executeTaggeo,
      setFromActionValue,
      setMaxAmountValue,
      getAmountOfTelcelPospago
    },
    dispatch
  );
}

HasDomiciliationModal = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(HasDomiciliationModal);

